import { render, staticRenderFns } from "./UserChoose.vue?vue&type=template&id=1bb985e0&scoped=true&"
import script from "./UserChoose.vue?vue&type=script&lang=js&"
export * from "./UserChoose.vue?vue&type=script&lang=js&"
import style0 from "./UserChoose.vue?vue&type=style&index=0&id=1bb985e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb985e0",
  null
  
)

export default component.exports